function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBtnHeaderBack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z",
  style: {
    fill: "transparent"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m18.035 17.547-8.5 8.5 8.5 8.5",
  "data-name": "Path 473",
  style: {
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000",
    strokeWidth: "1.3px"
  },
  transform: "translate(-2.5 -10.047)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 0H0",
  "data-name": "Line 7",
  style: {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1.3px"
  },
  transform: "translate(7 15.953)"
}));
export default SvgBtnHeaderBack;